import { WEATHER_BOARD_ID } from 'components/WallBoardForm/constants';

// The wallboard's slides in rotation order. Slide ids that no longer resolve
// (e.g. a deleted dashboard) are dropped.
const resolveWallboardSlides = ({
  wallboard,
  allDashboards,
}: {
  wallboard: Wallboard;
  allDashboards: DashboardType[];
}): WallboardSlide[] =>
  wallboard.wallBoardDashboardIds
    .map((id) => {
      if (id === WEATHER_BOARD_ID) {
        return { id: WEATHER_BOARD_ID, name: 'Weather' };
      }
      const leaderboard = (wallboard.driverLeaderboards ?? []).find(
        (l) => l.id === id,
      );
      if (leaderboard) {
        return leaderboard;
      }
      return allDashboards.find((wbd) => wbd.id === id);
    })
    .filter((wbd) => !!wbd) as WallboardSlide[];

export default resolveWallboardSlides;
